var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"ly-tab-item",class:_vm.disabled ? 'text-muted' : '',style:(_vm.$parent.value === _vm.id ? _vm.activeStyle : {}),on:{"click":_vm.onItemClicked}},[_c('div',{staticClass:"ly-tab-item-label"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }